const store = {
  state: {
    loading: false,
    menu: true
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store.js